








import { defineComponent, onMounted, onUnmounted, computed, watch } from '@vue/composition-api';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';
import ComparisonView from '@/components/ComparisonView.vue';
import ListView from '@/components/ListView.vue';
import { MutationTypes } from '@/store/mutations';
import { useLocalStorage } from '@/util/LocalStorage';
import { WindowWatcher } from '@/util/WindowWatcher';

interface PropsInterface {
    apiUrl: string;
    emptyContentDivId: string;
    localStorageKey: string;
    auxData: string;
    whatsappHint: string;
    state: string;
    itemsPerPage?: number;
}

export default defineComponent({
    name: 'App',
    components: { ComparisonView, ListView },
    props: {
        apiUrl: { type: String, required: true },
        emptyContentDivId: { type: String, required: true },
        localStorageKey: { type: String, required: true },
        whatsappHint: { type: String, required: true },
        state: { type: String, default: '' },
        auxData: { type: String, required: true },
        itemsPerPage: { type: Number, required: false }
    },
    setup (props: PropsInterface) {
        const store = useStore();
        store.commit(MutationTypes.SetApiUrl, props.apiUrl);
        store.commit(MutationTypes.SetEmptyContentDivId, props.emptyContentDivId);
        store.commit(MutationTypes.SetAuxData, props.auxData);
        store.commit(MutationTypes.SetWhatsappHint, props.whatsappHint);
        props.itemsPerPage && store.commit(MutationTypes.SetItemsPerPage, props.itemsPerPage);

        useLocalStorage().setKey(props.localStorageKey);

        store.dispatch(ActionTypes.InitState, props.state);

        const windowWatcher = new WindowWatcher(store);

        onMounted(() => {
            windowWatcher.attachListener();
            windowWatcher.watch();
        });

        onUnmounted(() => {
            windowWatcher.detachListener();
        });

        const listHasItems = computed(() => store.state.items.length > 0);

        watch(listHasItems, value => {
            const element = document.getElementById(store.state.emptyContentDivId);
            if (!element) {
                throw new Error(`Element with id "${store.state.emptyContentDivId}" does not exist`);
            }
            element.style.display = value ? 'none' : 'block';
        }, { immediate: true });

        const component = computed(() => store.state.isComparing ? 'ComparisonView' : 'ListView');

        return { listHasItems, component };
    }
});
